










































































import {Component, Vue, Prop} from 'vue-property-decorator'
import {$, ID, error, successAndPush, sleep} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {ItrackCollection, cnpj} from '@/helpers'
import MotoristaEResponsaveisRequest from '@/model/request/MotoristaEResponsaveisRequest'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'
import moment from 'moment'

const sha1 = require('sha1')

const metaInfo = () => ({
  title: $.t('view.persist.driverPersist.title'),
})

@Component({
  metaInfo,
})
export default class DriverPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig
  Helper = Helper

  motoristaReq = new MotoristaEResponsaveisRequest()
  cpfChecked = false
  allFilial = ItrackCollection.allFilial

  async mounted() {
    if (this.id) {
      await this.motoristaReq.motorista.find(this.id)
    }
    await this.allFilial.query()
    this.allFilial.items.forEach((item: Responsavel) => {
      let nomeFantasia = ''
      if (item.nomeFantasia) {
        nomeFantasia = `${$.filter.truncate(item.nomeFantasia || '', 20)} - `
      }

      item.$tag = `${nomeFantasia}${Helper.cnpj(item.cnpj)}`
    })
    $.await.done('findMotorista')
  }

  get resourceSelect() {
    return {
      tipoVeiculo: ItrackCollection.allTipoVeiculo.nullableItems(),
      marcaVeiculo: ItrackCollection.allMarcaVeiculo.nullableItems(),
      tipoCarroceria: ItrackCollection.allTipoCarroceria.nullableItems(),
    }
  }

  async checkIfCpfExist() {
    await this.motoristaReq.motorista.checkExists(this.motoristaReq.motorista.cpf, 'checkIfCpfExist')
    this.cpfChecked = true
  }

  async persist() {
    // await this.motoristaReq.motorista.endereco.populateLatLng()

    if (this.motoristaReq.motorista.dataNascimento) {
      this.motoristaReq.motorista.dataNascimento = moment(this.motoristaReq.motorista.dataNascimento)
          .utcOffset('-03:00', true)
          .format()
    }

    this.motoristaReq.motorista.senha = sha1((Math.random() * 1e32).toString(36))
    await this.motoristaReq.motorista.validate()

    if (Helper.getPermitirRoterizacao() ) {
        try {
            await this.motoristaReq.motorista.jornadaMotorista.validateJornadaDias()
        } catch (e) {
            this.$snotify.error($.t('view.persist.driverPersist.errorJorneyEmpty'))
            return
        }
    }

    await this.motoristaReq.save()
    successAndPush('system.success.persist', '/manage/driver/list')
  }
}
